import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RESPONSES_QUERY_KEYS } from 'components/responses/constants';
import { api } from 'controllers/network/apiClient';
import { SalesShopsData } from '../types';

export const useSalesShopData = (): UseQueryResult<SalesShopsData> => {
  return useQuery({
    queryKey: [RESPONSES_QUERY_KEYS.SHOP_DATA],
    queryFn: async (): Promise<SalesShopsData> => {
      return api.get('/v2/convert/shop/data');
    },
  });
};
